var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"main-app"}},[_c('admin-header'),_c('v-main',{staticClass:"d-flex flex-column",attrs:{"id":"content-wrapper"}},[_c('admin-sidebar'),_c('v-container',{staticClass:"main-container",attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }